import { AuthContext, CommonContext } from '@repo-level/core-front';
import { FullInformation } from 'components/auth/FullInformation';
import { Registration } from 'components/auth/Registration';
import { Deposit } from 'components/Deposit';
import { checkCompleteUserInformation } from 'components/Deposit/helpers';
import { ModalDefaultProps } from 'components/Modal';
import { ModalTemplate } from 'components/ModalTemplate';
import { ModalTemplateSettings } from 'components/ModalTemplate/types';
import {
  LocalStorageDeposit,
  removeQueryParameterWithNavigation,
} from 'helpers/common';
import { Country } from 'helpers/conf';
import { useMedia } from 'modules/common/hooks/useMedia';
import { forwardRef, useCallback, useContext, useMemo } from 'react';
import { useCurrentRoute, useNavigation } from 'react-navi';

export const DepositModal = forwardRef<HTMLDivElement, ModalDefaultProps>(
  ({ onClose, onScrollTo }, ref) => {
    const { user, pendingUser, setCurrentAmount } = useContext(AuthContext);
    const { currentIp, currencies } = useContext(CommonContext);
    const { isMobileS } = useMedia();

    const navigation = useNavigation();
    const {
      url: { query },
    } = useCurrentRoute();

    const modalSettings: ModalTemplateSettings = useMemo(() => {
      return isMobileS
        ? {
            type: 'mobile',
            mode: { type: 'insideCrossButton' },
            smallYPadding: true,
          }
        : {
            type: 'desktop',
            size: 'xLarge',
            mode: { type: 'default' },
          };
    }, [isMobileS]);

    const removeVipQuery = useCallback(() => {
      if (query.vip) {
        removeQueryParameterWithNavigation(navigation, query, 'vip');
      }
    }, [navigation, query]);

    const handleClose = useCallback(() => {
      removeVipQuery();

      onClose && onClose();
    }, [onClose, removeVipQuery]);

    const handleCloseDeposit = useCallback(() => {
      removeVipQuery();

      LocalStorageDeposit.remove();
      setCurrentAmount(0);

      onClose && onClose();
    }, [onClose, removeVipQuery, setCurrentAmount]);

    if (user?.id == null && !pendingUser) {
      return <Registration onClose={handleClose} ref={ref} />;
    }

    if (
      (!checkCompleteUserInformation(
        user,
        currentIp?.countryCode === Country.France
      ) ||
        user?.state === null) &&
      currencies.find(({ code }) => code === user?.currency)?.fiat
    ) {
      return <FullInformation onClose={handleClose} ref={ref} />;
    }

    return (
      <ModalTemplate
        ref={ref}
        onClose={handleCloseDeposit}
        settings={modalSettings}
        positionCrossButton={isMobileS ? { top: 16, right: 16 } : undefined}
        isCrossSquare={isMobileS ? false : true}
      >
        <Deposit onScrollTo={onScrollTo} />
      </ModalTemplate>
    );
  }
);
